import { render } from "./MyOrdersView.vue?vue&type=template&id=09260133"
import script from "./MyOrdersView.vue?vue&type=script&lang=js"
export * from "./MyOrdersView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__